import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { TreeProps } from 'ant-design-vue'
import { ref } from 'vue'
import tree from '@/components/Tree'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const treeData = ref<TreeProps['treeData']>([
  {
    title: '一、系统设置',
    key: '0-0',
    children: [
      {
        title: 'parent 1-0',
        key: '0-0-0',
        children: [
          { title: 'leaf', key: '0-0-0-0' },
          {
            key: '0-0-0-1',
            title: '22323'
          },
          { title: 'leaf', key: '0-0-0-2' }
        ]
      },
      {
        title: 'parent 1-1',
        key: '0-0-1',
        children: [{ title: 'leaf', key: '0-0-1-0' }]
      },
      {
        title: 'parent 1-2',
        key: '0-0-2',
        children: [
          { title: 'leaf 1', key: '0-0-2-0' },
          {
            title: 'leaf 2',
            key: '0-0-2-1',
            children: [
              { title: 'leaf 1', key: '0-0-2-1-0' },
              {
                title: 'leaf 2',
                key: '0-0-2-1-1'
              }
            ]
          }
        ]
      }
    ]
  },
  {
    title: '二、应用设置',
    key: '0-1',
    children: [
      {
        title: 'parent 1-0',
        key: '0-1-0',
        children: [
          { title: 'leaf', key: '0-0-0-1' },
          {
            key: '0-1-0-1',
            title: '22323'
          },
          { title: 'leaf', key: '0-1-0-2' }
        ]
      },
      {
        title: 'parent 1-1',
        key: '0-1-1',
        children: [{ title: 'leaf', key: '0-2-1-0' }]
      },
      {
        title: 'parent 1-2',
        key: '0-1-2',
        children: [
          { title: 'leaf 1', key: '0-2-2-0' },
          {
            title: 'leaf 2',
            key: '1-0-2-1',
            children: [
              { title: 'leaf 1', key: '0-2-2-1-0' },
              {
                title: 'leaf 2',
                key: '1-2-2-1-1'
              }
            ]
          }
        ]
      }
    ]
  }
])

return (_ctx: any,_cache: any) => {
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, { "is-breadcrumb": true }, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_unref(tree), { "tree-data": treeData.value }, null, 8, ["tree-data"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})